<template>
  <div ref="WangEditor"></div>
</template>

<script>
import Editor from "wangeditor";
export default {
  props: {
    content: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: Number,
      default: 250,
    },
    minWidth: {
      type: Number,
      default: 650,
    },
    minHeight: {
      type: Number,
      default: 100,
    },
  },
  name: "wang-editor",
  data() {
    return {
      editor: null,
      contents: '',
      uploadUrl: this.http.ipAddress + 'api/Common/FileUpload',
    };
  },
  watch: {
    value(newVal) {
      if (newVal != this.contents) {
        this.editor.txt.html(newVal);
      }
      this.contents = newVal;
    },
  },
  destroyed() {
    this.editor = null;
  },
  mounted() {
    this.editor = null;
    let editor = new Editor(this.$refs.WangEditor);
    this.editor = editor;
    let $this = this;
    editor.config.height = this.height;
    editor.config.onchange = (html) => {
      this.contents=html;
      html = html.replace(/<table border="0"/g, '<table border="1"');//表格默认添加边框
      this.$emit("input", html);
    };

    //上传地址
    editor.config.uploadImgServer = this.uploadUrl;
    // console.log(editor.config.uploadImgServer);
    editor.config.customUploadImg = function (resultFiles, insertImgFn) {
      let formData = new FormData();
      let nameArr = [];
      resultFiles.forEach(function (file) {
        formData.append("fileInput", file, file.name);
        nameArr.push(file.name);
      });

      $this.http.post($this.uploadUrl, formData, true).then((x) => {
        if (!x.Code) {
          return $this.$message.error(x.Message);
        }
        let imgs = nameArr
          .map((m) => {
            return x.Data;
          })
          .join(",");
        insertImgFn(imgs);
      });
    };
    editor.create();
    editor.txt.html(this.value);
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/WangEditor.vue